import React from 'react';
import MarketsTable from './MarketsTable';

import PageHeader from '../components/PageHeader'

import aboutBg from '../../../images/about-bg.jpg';

/* Markets page */
const Markets = () => (
  <div>
    <PageHeader 
      heading="Markets"
      subheading="Forex & Indices"
      backgroundImage={{backgroundImage: `url(${aboutBg})`}} />

    <div className="container">
      <div className="row">
        <div className="col-xs-12 text-center">
          <h1 className="section-heading">Forex</h1>
          <p>The foreign exchange market is the "place" where currencies are traded. Currencies are important to most people around the world, whether they realize it or not, because currencies need to be exchanged in order to conduct foreign trade and business. if you are living in the U.S. and want to buy cheese from France, either you or the company that you buy the cheese from has to pay the French for the cheese in euros (EUR). This hello world means that the U.S. importer would have to exchange the equivalent value of U.S. dollars (USD) into euros. The same goes for traveling. A French tourist in Egypt can't pay in euros to see the pyramids because it's not the locally accepted currency. As such, the tourist has to exchange the euros for the local currency, in this case the Egyptian pound, at the current exchange rate Read more: <a target="_blank" href="http://www.investopedia.com/university/forexmarket/forex1.asp#ixzz4gaoW1AZc">Forex Tutorial: What is Forex Trading?</a></p>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 text-center">
          <h1 className="section-heading">Indices</h1>
          <p>An Index is used to give information about the price movements of products in the financial, commodities or any other markets. Financial indexes are constructed to measure price movements of stocks, bonds, T-bills and other forms of investments. Stock market indexes are meant to capture the overall behaviour of equity markets. A stock market index is created by selecting a group of stocks that are representative of the whole market or a specified sector or segment of the market. An Index is calculated with reference to a base period and a base index value.</p>
          <p>Stock market indexes are useful for a variety of reasons. Some of them are :</p>
          <ul className="col-md-9 col-md-push-2 text-left">
            <li>They provide a historical comparison of returns on money invested in the stock market against other forms of investments such as gold or debt.</li>
            <li>They can be used as a standard against which to compare the performance of an equity fund.</li>
            <li>In It is a lead indicator of the performance of the overall economy or a sector of the economy</li>
            <li>Stock indexes reflect highly up to date information</li>
            <li>Modern financial applications such as Index Funds, Index Futures, Index Options play an important role in financial investments and risk management</li>
          </ul>
        </div>
      </div>
      <hr />
      <div className="row">
        <div className="col-xs-12">
          <MarketsTable />
        </div>
      </div>
    </div>
  </div>
)

export default Markets



// WEBPACK FOOTER //
// ./src/components/pages/Markets/Markets.js